import { useMutation } from 'react-query';
import {
  doFirebaseAuthAsync,
  doInternalRegisterAsync,
  doLoginAsync,
  doRegisterAsync,
  QRCodeLoginAsync,
} from '../../index';

export const useDoLogin = () => useMutation(doLoginAsync);
export const useDoFirebaseLogin = () => useMutation(doFirebaseAuthAsync);

export const useDoRegisterAsync = () => useMutation(doRegisterAsync);

export const useDoRegisterInternalAsync = () =>
  useMutation(doInternalRegisterAsync);

export const useQRCodeLoginAsync = () => useMutation(QRCodeLoginAsync);
